// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Al3y","controls":"styles_controls__Y6pwV","charLimit":"styles_charLimit__3tn4r","input":"styles_input__3SyS5","send":"styles_send__3DaRb"};